import { useState, useEffect } from 'react';

export interface ReportSettings {
  fromZero: boolean;
  showScheme: boolean;
  showPieceTags: boolean;
  showTextScheme: boolean;
}

export const DEFAULT_SETTINGS: ReportSettings = {
  fromZero: false,
  showScheme: true,
  showPieceTags: true,
  showTextScheme: true,
};

const LS_KEY = 'linecut:report-settings';

export function useReportSettings() {
  const [settings, setSettings] = useState<ReportSettings>(() => {
    try {
      const raw = localStorage.getItem(LS_KEY);
      if (raw) return { ...DEFAULT_SETTINGS, ...(JSON.parse(raw) as Partial<ReportSettings>) };
    } catch { /* ignore */ }
    return DEFAULT_SETTINGS;
  });

  useEffect(() => {
    localStorage.setItem(LS_KEY, JSON.stringify(settings));
  }, [settings]);

  function toggleSetting(key: keyof ReportSettings) {
    setSettings((prev) => ({ ...prev, [key]: !prev[key] }));
  }

  return { settings, toggleSetting };
}
